import { render, staticRenderFns } from "./SingleNotification.vue?vue&type=template&id=78f52510"
import script from "./SingleNotification.vue?vue&type=script&lang=js"
export * from "./SingleNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78f52510')) {
      api.createRecord('78f52510', component.options)
    } else {
      api.reload('78f52510', component.options)
    }
    module.hot.accept("./SingleNotification.vue?vue&type=template&id=78f52510", function () {
      api.rerender('78f52510', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/drc/components/notifications/SingleNotification.vue"
export default component.exports